import React from "react";
import { TextField, MenuItem } from "@mui/material";

const SelectFieldforAdminSettings = ({
  label,
  options,
  placeholder,
  value,
  onChange,
  name,
  id,
  margin,
  isRequired = true,
  disabled
}) => {
  return (
    <TextField
      select
      label={
        <span>
          {label} {isRequired && <span style={{ color: "red" }}>*</span>}
        </span>
      }
      variant="outlined"
      fullWidth
      id={id}
      name={name}
      disabled={disabled}
      value={value || ""} // Set value directly
      onChange={onChange} // Standard onChange handler
      InputLabelProps={{
        shrink: true,
        sx: {
          position: "absolute",
          top: "-27px",
          padding: "0 4px",
          left: "14px",
          fontSize: "12px",
          marginLeft: "-4px",
          transform: "translate(0, 4px)",
          lineHeight: "40px",
        },
      }}
      SelectProps={{
        displayEmpty: true,
        MenuProps: {
          PaperProps: {
            sx: {
              maxHeight: 224,
              maxWidth: 350,
            },
          },
        },
        sx: {
          color: value === "" ? "#9e9e9e" : "inherit",
        },
      }}
      sx={{
        marginTop: margin || 0,
        "& .MuiInputBase-root": {
          height: 40,
        },
        "& .MuiSelect-select": {
          display: "flex",
          alignItems: "center",
          height: "100%",
          padding: "0 18px",
          fontFamily: "Urbane-Light",
        },
        "& .MuiInputBase-input": {
          padding: "0 39px",
          fontSize: "12px",
          margin: "-1px",
          fontFamily: "Urbane-Light",
        },
        "& .MuiFormControl-root": {
          height: "100%",
        },
        "& .MuiInputLabel-root": {
          lineHeight: "40px",
        },
        "& .MuiSelect-select:empty": {
          color: "#9e9e9e",
        },
      }}
      renderValue={(selected) => {
        if (selected === "") {
          return <span style={{ color: "#9e9e9e" }}>{placeholder}</span>;
        }
        return options.find((option) => option.value === selected)?.label;
      }}
    >
      <MenuItem
        value=""
        disabled
        sx={{
          display: "none",
        }}
      >
        {placeholder}
      </MenuItem>
      {options.map((option, index) => (
        <MenuItem key={index} value={option.value}  disabled={option.disabled}  sx={{ height: 40 }}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default SelectFieldforAdminSettings;
